window.inn = window.inn || {};
//Common
export const CSRFtoken = window.inn.CSRFtoken;

//Login
export const cellphone = window.inn.cellphone;
export const redirectURI = window.inn.redirectURI;
export const hashContent = window.location.hash;
export const UserCheckout = window.inn.UserCheckout;
export const SessionCheck = window.inn.SessionCheck;
//Traq consent permission checkpoint from login (If a user tries to log in without a valid/active “allow to login to Opplysningen services” consent, we introduce a new page in the log-in flow )
export const usertokenid = window.inn.usertokenid;
export const default_login_title = window.inn.default_login_title;
//Login error
export const loginError = window.inn.loginError;
//export const loginError = true;
export const loginType = window.inn.loginType;
export const changePwdError = window.inn.changePwdError;
//Password
export const username = window.inn.username;

//CRMcustomer
export const CRMcustomer = window.inn.CRMcustomer;

//Consent screen
export const firstname = window.inn.firstname;
export const lastname = window.inn.lastname;
export const phoneNo = window.inn.phoneNo;
export const appId = window.inn.appId;
export const appName = window.inn.appName;
export const token = window.inn.token;
export const logoutURI = window.inn.logoutURI;
export const email = window.inn.email;

//password reminder error
export const resetPasswordError = window.inn.resetPasswordError;

export const targetApplicationId = window.inn.targetApplicationId;

export const vippsLoginEnabled = window.inn.vippsLoginEnabled;

export const provider = window.inn.provider;

export const clientId = window.inn.clientId;

export const promo = window.inn.promo;
